// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__Rd8c7","slider":"switch_slider__OqPLz"};